<template>
  <div class="popup-feedback">
    <ButtonClose class="popup-feedback__close" @click="close" />
    <div class="popup-feedback__media">
      <img class="popup-feedback__img" src="@/assets/img/popup_img.jpg" width="416" height="697" alt="">
    </div>
    <div class="popup-feedback__info">
      <Title3 class="popup-feedback__title" v-html="getValue('popup.title')" />
      <p class="popup-feedback__desc" v-html="getValue('popup.subtitle')"></p>
      <FeedbackForm class="popup-feedback__form"
        :content="{bnt: getValue('popup.btn.text'), success: getValue('success') }" />
    </div>
  </div>
</template>

<script>
import ButtonClose from "@/components/element/ButtonClose.vue";
import Title3 from "@/components/element/Title3App.vue";
import FeedbackForm from "@/components/block/FeedbackForm.vue";
import { getValue } from '@/helpers/index.js';

export default {
  name: 'PopupFeedback',
  components: {
    ButtonClose,
    Title3,
    FeedbackForm
  },
  props: {
    content: {
      required: true,
      default: () => ({}),
    },
  },
  computed: {
    getValue() {
      return (path) => {
        return getValue(this.content, path, "");
      }
    },
  },
  methods: {
    close() {
      this.$store.commit('updateClose');
    }
  },
};
</script>

<style>
.popup-feedback {
  position: relative;

  display: flex;
  width: 1298px;

  background-color: #0c1427;
}

.popup-feedback__close {
  position: absolute;
  top: 30px;
  right: 30px;
}

.popup-feedback__media {
  flex-shrink: 0;
  width: 416px;
}

.popup-feedback__img {
  height: 100%;

  object-fit: cover;
  object-position: center;
}

.popup-feedback__info {
  padding: 110px 80px 110px 50px;
}

.popup-feedback__title {
  margin-bottom: 50px;
  text-transform: uppercase;
}

.popup-feedback__desc {
  margin-bottom: 50px;
}

@media screen and (max-width: 1919.98px) {
  .popup-feedback {
    width: 1180px;
  }

  .popup-feedback__close {
    top: 20px;
    right: 20px;
  }

  .popup-feedback__media {
    width: 390px;
  }

  .popup-feedback__info {
    padding: 100px 60px 80px 40px;
  }

  .popup-feedback__title {
    margin-bottom: 45px;
  }

  .popup-feedback__desc {
    margin-bottom: 45px;
  }
}

@media screen and (max-width: 1599.98px) {
  .popup-feedback {
    width: 1080px;
  }

  .popup-feedback__media {
    width: 360px;
  }

  .popup-feedback__title {
    margin-bottom: 40px;
  }

  .popup-feedback__desc {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 1199.98px) {
  .popup-feedback {
    width: 940px;
  }

  .popup-feedback__media {
    width: 340px;
  }

  .popup-feedback__info {
    padding: 100px 60px 80px 40px;
  }

  .popup-feedback__title {
    margin-bottom: 40px;
  }

  .popup-feedback__desc {
    margin-bottom: 40px;
  }
}

@media screen and (max-width: 991.98px) {
  .popup-feedback {
    width: 720px;
  }

  .popup-feedback__media {
    width: 340px;
  }

  .popup-feedback__info {
    padding: 70px 40px 40px 30px;
  }

  .popup-feedback__title {
    margin-bottom: 30px;
  }

  .popup-feedback__desc {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 767.98px) {
  .popup-feedback {
    align-items: center;
    width: 100%;
    height: 100%;
  }

  .popup-feedback__media {
    display: none;
  }

  .popup-feedback__info {
    padding: 100px 100px 60px 100px;
  }

  .popup-feedback__title {
    margin-bottom: 30px;
  }

  .popup-feedback__desc {
    margin-bottom: 30px;
  }
}

@media screen and (max-width: 575.98px) {
  .popup-feedback {
    width: 100%;
    height: 100%;

  }

  .popup-feedback__info {
    padding: 60px 25px 60px 25px;
  }
}
</style>
